export default __webpack_public_path__ + "img/cipwyh.5f64ffe1.svg";